import http from './http'

export default {
  me: () => http.get('/v2/users/me')
}



// WEBPACK FOOTER //
// ./src/services/api/users.js